var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_setup.panelThemes({
      size: _setup.size,
      enableVerticalScroll: _setup.props.enableVerticalScroll,
    }).root(),style:({
    '--vertical-padding': `${_setup.size === 'full' ? '48' : _setup.verticalPadding}px`,
    '--modal-header-height': _setup.hasModalHeader ? '45px' : '0px',
    '--modal-footer-height': _setup.hasModalFooter ? '60px' : '0px',
  }),attrs:{"data-slot":"panel"}},[_c('div',{class:_setup.panelThemes({
        size: _setup.size,
        enableVerticalScroll: _setup.props.enableVerticalScroll,
      }).container(),attrs:{"data-slot":"panel-container"}},[_c(_setup.CsTransitionChild,{attrs:{"enter-active-class":"transition ease-out duration-300","enter-class":"opacity-0 translate-y-4","enter-to-class":"opacity-100 translate-y-0","leave-active-class":"transition ease-in duration-200","leave-class":"opacity-100 translate-y-0","leave-to-class":"opacity-0 translate-y-4"}},[_c('div',{class:_setup.panelThemes({
            size: _setup.size,
            enableVerticalScroll: _setup.props.enableVerticalScroll,
          }).content(),attrs:{"data-slot":"panel-content"}},[_vm._t("default")],2)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }